// Documentation module translations - Italian (Italiano)
export const documentationIT = {
  // Common
  'Documentation': 'Documentazione',
  'Need Help?': 'Hai Bisogno di Aiuto?',
  'Email': 'Email',
  'Documentation Center': 'Centro Documentazione',
  'Check other guides in the Documentation Center': 'Consulta altre guide nel Centro Documentazione',
  'If you have questions about payment modes or booking management, our support team is here to help:':
    'Se hai domande sui metodi di pagamento o sulla gestione delle prenotazioni, il nostro team di supporto è qui per aiutarti:',

  // Categories
  'Studio Bookings': 'Prenotazioni Studio',
  'Event Setup': 'Configurazione Eventi',
  'Tickets & Pricing': 'Biglietti e Prezzi',

  // Payment Mode Documentation
  'Payment Mode Management Guide': 'Guida alla Gestione dei Metodi di Pagamento',
  'This comprehensive guide explains how to configure payment modes for your studio bookings and manage the booking approval workflow. Payment modes control how customers pay for their bookings and when money is collected.':
    'Questa guida completa spiega come configurare i metodi di pagamento per le prenotazioni del tuo studio e gestire il flusso di approvazione delle prenotazioni. I metodi di pagamento controllano come i clienti pagano per le loro prenotazioni e quando viene raccolto il denaro.',

  // Overview Section
  'Overview: Understanding Payment Modes': 'Panoramica: Comprendere i Metodi di Pagamento',
  'The system supports four different payment modes, each designed for different business needs:':
    'Il sistema supporta quattro diversi metodi di pagamento, ciascuno progettato per diverse esigenze aziendali:',

  // Payment Modes
  'Manual Mode': 'Modalità Manuale',
  'Full Payment Mode': 'Modalità Pagamento Completo',
  'Deposit Mode': 'Modalità Deposito',
  'Hold Mode': 'Modalità Trattenuta',

  // Payment Mode Labels
  'No online payment': 'Nessun pagamento online',
  'Instant charge': 'Addebito istantaneo',
  'Partial charge': 'Addebito parziale',
  'Authorization hold': 'Trattenuta autorizzazione',

  // Payment Mode Descriptions
  'Customer submits booking request without paying online. Owner approves, then collects payment later (cash, invoice, etc.)':
    'Il cliente invia la richiesta di prenotazione senza pagare online. Il proprietario approva, poi raccoglie il pagamento in seguito (contanti, fattura, ecc.)',
  'Customer pays 100% upfront via online payment. Booking is automatically confirmed once payment succeeds.':
    'Il cliente paga il 100% in anticipo tramite pagamento online. La prenotazione viene confermata automaticamente una volta che il pagamento ha successo.',
  'Customer pays a deposit upfront (e.g., 30%). Remaining balance collected later (before/after session).':
    'Il cliente paga un deposito in anticipo (es. 30%). Il saldo rimanente viene raccolto in seguito (prima/dopo la sessione).',
  'Card is authorized but NOT charged. Owner approves booking → money is captured. Owner rejects → hold is released.':
    'La carta è autorizzata ma NON addebitata. Il proprietario approva la prenotazione → il denaro viene catturato. Il proprietario rifiuta → la trattenuta viene rilasciata.',

  // Configuration Section
  'How to Configure Payment Settings': 'Come Configurare le Impostazioni di Pagamento',
  'Payment settings are configured per studio in the Manage Settings page under the Pricing & Payment tab. Navigate to: Studios → [Your Studio] → Manage Settings → Pricing & Payment':
    'Le impostazioni di pagamento sono configurate per studio nella pagina Gestisci Impostazioni sotto la scheda Prezzi e Pagamenti. Naviga su: Studi → [Il Tuo Studio] → Gestisci Impostazioni → Prezzi e Pagamenti',

  // Configuration Steps
  'Access Payment Settings': 'Accedi alle Impostazioni di Pagamento',
  'Select Payment Mode': 'Seleziona Metodo di Pagamento',
  'Configure Deposit Settings (if using Deposit Mode)': 'Configura Impostazioni Deposito (se usi Modalità Deposito)',
  'Configure Booking Rules': 'Configura Regole di Prenotazione',
  'Save Your Changes': 'Salva le Modifiche',

  // Booking Management
  'Managing Booking Requests': 'Gestione Richieste di Prenotazione',
  'Understanding Booking Statuses': 'Comprendere gli Stati di Prenotazione',
  'Understanding Payment Statuses': 'Comprendere gli Stati di Pagamento',

  // Workflow
  'Workflow: Approving Bookings (Manual & Hold Modes)': 'Flusso di Lavoro: Approvazione Prenotazioni (Modalità Manuale e Trattenuta)',
  'View Pending Approvals': 'Visualizza Approvazioni in Sospeso',
  'Review Booking Details': 'Rivedi Dettagli Prenotazione',
  'Approve the Booking': 'Approva la Prenotazione',
  'Reject the Booking (if needed)': 'Rifiuta la Prenotazione (se necessario)',

  // Best Practices
  'Best Practices & Tips': 'Migliori Pratiche e Suggerimenti',
  'Choose the Right Mode for Your Business': 'Scegli la Modalità Giusta per la Tua Attività',
  'Respond to Booking Requests Quickly': 'Rispondi Rapidamente alle Richieste di Prenotazione',
  'Provide Clear Rejection Reasons': 'Fornisci Ragioni di Rifiuto Chiare',
  'Set Appropriate Deposit Amounts': 'Imposta Importi di Deposito Appropriati',
  'Monitor Your Booking Dashboard': 'Monitora la Tua Dashboard Prenotazioni',
  'Track Your Revenue': 'Traccia i Tuoi Ricavi',

  // Quick Reference
  'Quick Reference: Payment Mode Comparison': 'Riferimento Rapido: Confronto Metodi di Pagamento',

  // Table Headers and Common Terms
  'Status': 'Stato',
  'What It Means': 'Cosa Significa',
  'Payment Status': 'Stato Pagamento',
  'Actions Available': 'Azioni Disponibili',
  'Feature': 'Caratteristica',
  'Manual': 'Manuale',
  'Full Payment': 'Pagamento Completo',
  'Deposit': 'Deposito',
  'Hold': 'Trattenuta',
  'Best For': 'Ideale Per',
  'Mode': 'Modalità',

  // Payment Statuses
  'Unpaid': 'Non Pagato',
  'Pending': 'In Sospeso',
  'On Hold': 'In Trattenuta',
  'Deposit Paid': 'Deposito Pagato',
  'Paid': 'Pagato',
  'Refunded': 'Rimborsato',

  // Booking Statuses
  'Pending Approval': 'In Attesa di Approvazione',
  'Confirmed': 'Confermato',
  'In Progress': 'In Corso',
  'Completed': 'Completato',
  'Rejected': 'Rifiutato',
  'Cancelled': 'Annullato',
  'No Show': 'Assente',

  // Actions
  'Approve': 'Approva',
  'Reject': 'Rifiuta',
  'View': 'Visualizza',
  'Cancel': 'Annulla',
  'Mark In Progress': 'Segna In Corso',
  'Mark Completed': 'Segna Completato',
  'Collect Balance': 'Raccogli Saldo',

  // Common Descriptions
  'No payment received yet. Common in manual mode bookings before collection.':
    'Nessun pagamento ricevuto ancora. Comune nelle prenotazioni in modalità manuale prima della raccolta.',
  'Payment initiated but not completed. Customer in checkout process.':
    'Pagamento avviato ma non completato. Cliente in processo di checkout.',
  'Full payment received and confirmed. No balance owed.':
    'Pagamento completo ricevuto e confermato. Nessun saldo dovuto.',
  'Payment was refunded back to customer (full or partial refund).':
    'Il pagamento è stato rimborsato al cliente (rimborso totale o parziale).',
};
